import { useEffect, useState } from "react"
import PaymentFailurePage from "../../../components/Acknowledgement/Signup/PaymentFailure/PaymentFailurePage"
import PaymentPendingPage from "../../../components/Acknowledgement/Signup/PaymentPending/PaymentPendingPage"
import PaymentSuccessPage from "../../../components/Acknowledgement/Signup/PaymentSuccess/PaymentSuccessPage"
import { getPaymentResult } from "../../../services/ntuc/paymentService/payment"
import { searchParams } from '../../../helpers/search-params'
import { SignupRouteParams } from "../SignupFlow/SignupFlow"
import { getWebCampaign } from "../../../services/ntuc/memberService/campaign"
import { useCookies } from "react-cookie"
import { AppCookies } from "../../../helpers/cookies"
import { getPayment, OrderStatus, PaymentResponse } from "../../../services/ntuc/memberService/payment"
import { trackSignUpStep } from "../../../helpers/gtm"
interface AcknowledgementPageProps extends SignupRouteParams {
    membershipId?: string
    orderId?: string
    campaign?: Campaign
}

interface Campaign {
    code: string
    callback: string
    app: string
}

interface PaymentInfo {
    isRecurring: boolean | null
    membershipId: string
    orderStatus: OrderStatus
}

const AcknowledgementPage = (props: SignupRouteParams) => {
    const { onNavigateTo } = props
    const [cookies] = useCookies()
    const [campaign, setCampaign] = useState<Campaign>()
    const [orderId, setOrderId] = useState<string>()
    const [payment, setPayment] = useState<PaymentInfo>()

    const transformData = (content: PaymentResponse) => {
        return {
            isRecurring: content.payment.isRecurringPayment,
            membershipId: content.membershipPayment.membershipId,
            orderStatus: content.payment.orderStatus,
        }
    }

    const data = searchParams.Data
    const iv = searchParams.IV
    const tag = searchParams.tag || searchParams.Tag

    useEffect(() => {
        if (data && iv && tag) {
            getPaymentResult(data, iv, tag)
                .then(response => response.data.content.clientOrderId)
                .then(setOrderId)
                .catch(error => {
                    console.error(error.message)
                })
        }
    }, [data, iv, tag])

    useEffect(() => {
        if (orderId) {
            getPayment(orderId)
                .then(response => {
                    console.log(response.data.content)
                    const statusPayment = response.data.content.payment.orderStatus
                    trackSignUpStep(`Payment_${statusPayment}`)
                    return response
                })
                .then(response => response.data.content)
                .then(transformData)
                .then(setPayment)
                .catch(error => {

                    console.error(error.message)
                })
        }
    }, [orderId])

    useEffect(() => {
        if (cookies[AppCookies.CAMPAIGN_CODE] !== undefined) {
            getWebCampaign(cookies[AppCookies.CAMPAIGN_CODE])
                .then(response => response.data.content)
                .then(campaign => {
                    setCampaign({
                        code: campaign.campaign_code,
                        callback: campaign.callback_url,
                        app: campaign.calling_app,
                    })
                })
        }
    }, [cookies])

    switch (payment?.orderStatus) {
        case OrderStatus.SEMI_SUCCESS_RECURRING:
        case OrderStatus.SEMI_SUCCESS_ONE_TIME:
        case OrderStatus.SUCCESS:
            return <PaymentSuccessPage orderId={orderId} onNavigateTo={onNavigateTo} campaign={campaign} />
        case OrderStatus.FAILED:
        case OrderStatus.CANCELLED:
            return <PaymentFailurePage membershipId={payment.membershipId} orderId={orderId} onNavigateTo={onNavigateTo} campaign={campaign} />
        default:
            return <PaymentPendingPage onNavigateTo={onNavigateTo} orderId={orderId} />
    }
}

export default AcknowledgementPage
export type { AcknowledgementPageProps }

